import React from 'react';
import {Text} from 'react-native';
import {ScrollView} from 'react-native';
import {Text as RNText} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';

import MessageBanner from '../MessageBanner';

storiesOf('base', module).add('MessageBanner', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>MessageBanner</Heading>
        <Spacer size={16} />
        <Text>
          A basic <Code>{'<MessageBanner />'}</Code> can be rendered simply by
          passing a value to the <Code>message</Code> prop.
        </Text>
        <Spacer size={16} />
        <MessageBanner message="A message" />
        <Spacer size={10} />
        <Code>{'message="A message"'}</Code>
        <Spacer size={16} />
        <MessageBanner
          // @ts-expect-error TS(2769): No overload matches this call.
          message="A long multi-line message for this banner with an icon"
          iconName="learn"
        />
        <Spacer size={10} />
        <Code>{'iconName="learn"'}</Code>
      </FlexView>
      <FlexView>
        <Spacer size={24} />
        <Heading level={2}>Specifying an alertLevel</Heading>
        <Spacer size={16} />
        <Text>
          <Code>{'<MessageBanner />'}</Code> also respects the{' '}
          <Code>alertLevel</Code> prop for styling the icon color.
        </Text>
        <Spacer size={16} />
        <MessageBanner
          // @ts-expect-error TS(2769): No overload matches this call.
          message="A message"
          iconName="learn"
          alertLevel="error"
        />
        <Spacer size={10} />
        <Code>{'alertLevel="error"'}</Code>
      </FlexView>
      <FlexView>
        <Spacer size={24} />
        <Heading level={2}>Competency-themed Banners</Heading>
        <Spacer size={16} />
        <Text>
          <Code>{'<MessageBanner />'}</Code> also respects the{' '}
          <Code>useCompetency</Code> prop to use competency-based theme colors
          to style the icon color.
        </Text>
        <Spacer size={16} />
        <MessageBanner
          // @ts-expect-error TS(2769): No overload matches this call.
          message="A competency-themed banner"
          iconName="learn"
          useCompetency={true}
        />
        <Spacer size={10} />
        <Code>{'useCompetency={true}'}</Code>
      </FlexView>
      <FlexView>
        <Spacer size={24} />
        <Heading level={2}>Vertical Banners</Heading>
        <Spacer size={16} />
        <RNText>
          When the <Code>verticalBanner</Code> prop is set to true, the vertical
          banner will be used. The <Code>alertLevel</Code> prop can be used to
          style the banner colors.
        </RNText>
        <Spacer size={16} />
        <MessageBanner
          verticalBanner={true}
          alertLevel="important"
          message={'Here is a vertical MessageBanner!'}
        />
        <Spacer size={10} />
        <Code>{'verticalBanner={true}'}</Code>
        <Spacer size={10} />
        <Code>{'alertLevel="important"'}</Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
